(() => {
  const root = document.querySelector('[data-vsp-root]');
  if (!root) return;

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));

  const els = {
    gallery: $('[data-vsp-gallery]'),
    mainImage: $('[data-vsp-main-image]'),
    placeholder: $('[data-vsp-placeholder]'),
    thumbs: $$('[data-vsp-thumb]'),
    productTitle: $('[data-vsp-product-title]'),
    price: $('[data-vsp-price]'),
    delivery: $('[data-vsp-delivery]'),
    options: $('[data-vsp-options]'),
    colorOption: $('[data-vsp-color-option]'),
    colorList: $('[data-vsp-colors]'),
    colorName: $('[data-vsp-color-name]'),
    sizeOption: $('[data-vsp-size-option]'),
    sizeLabel: $('[data-vsp-size-label]'),
    sizeList: $('[data-vsp-sizes]'),
    upload: $('[data-vsp-upload]'),
    uploadBox: $('[data-vsp-upload-box]'),
    uploadIdle: $('[data-vsp-upload-idle]'),
    uploadPreview: $('[data-vsp-upload-preview]'),
    uploadThumb: $('[data-vsp-upload-thumb]'),
    uploadName: $('[data-vsp-upload-name]'),
    uploadRemove: $('[data-vsp-upload-remove]'),
    uploadLoading: $('[data-vsp-upload-loading]'),
    loadingGif: $('[data-vsp-loading-gif]'),
    loadingSpinner: $('[data-vsp-loading-spinner]'),
    loadingSteps: $('[data-vsp-loading-steps]'),
    loadingProgress: $('[data-vsp-loading-progress]'),
    preview: $('[data-vsp-preview]'),
    add: $('[data-vsp-add]'),
    buyNowWrap: $('[data-vsp-buy-now-wrap]'),
    buyNowForm: $('.vsp-buy-now-form'),
    quantity: $('[data-vsp-quantity]'),
    quantityDecrease: $('[data-vsp-quantity-decrease]'),
    quantityIncrease: $('[data-vsp-quantity-increase]'),
    status: $('[data-vsp-status]'),
    modal: $('[data-vsp-modal]'),
    modalImg: $('[data-vsp-modal-img]'),
    modalPlaceholder: $('[data-vsp-modal-placeholder]'),
    modalAdd: $('[data-vsp-modal-add]'),
    modalQuantity: $('[data-vsp-modal-quantity]'),
    modalQuantityDecrease: $('[data-vsp-modal-quantity-decrease]'),
    modalQuantityIncrease: $('[data-vsp-modal-quantity-increase]'),
    accordions: $$('[data-vsp-accordion]')
  };

  const JOBS = window.VanscapePersonalizerJobStore;
  if (!JOBS) {
    console.error('Vanscape Job-Store konnte nicht geladen werden.');
    return;
  }

  function jobContext(productHandle = state.productHandle, style = state.selectedStyle) {
    return {
      product_id: state.product?.id || root.dataset.productId || '',
      product_handle: productHandle,
      style: mapStyleToApi(style)
    };
  }

  function activeJob({ allowLatest = true } = {}) {
    return JOBS.getActive(jobContext(), { allowLatest });
  }

  const SS = {
    get jobId() { return activeJob()?.job_id || ''; },
    get designId() { return activeJob()?.design_id || ''; },
    get thumbUrl() { return activeJob()?.thumb_url || ''; },
    get style() { return activeJob()?.style || ''; },
    get productHandle() { return activeJob()?.product_handle || ''; },
    get selectedColor() { return activeJob()?.selected_color || activeJob()?.selection?.selected_color || ''; },
    get selectedSize() { return activeJob()?.selected_size || activeJob()?.selection?.selected_size || ''; },
    get variantId() { return activeJob()?.variant_id || activeJob()?.selection?.variant_id || ''; },
    setDesign({ job_id, design_id, thumb_url, style, product_handle, selected_color, selected_size, variant_id }) {
      const context = jobContext(product_handle, style);
      const existing = JOBS.get(job_id);
      const record = existing
        ? JOBS.update(job_id, {
          status: 'completed',
          design_id,
          thumb_url,
          selected_color,
          selected_size,
          variant_id,
          selection: { selected_color, selected_size, variant_id }
        })
        : JOBS.create(context, {
          job_id,
          status: 'completed',
          design_id,
          thumb_url,
          selected_color,
          selected_size,
          variant_id,
          selection: { selected_color, selected_size, variant_id }
        });
      if (record) JOBS.setActive(context, record.job_id);
    },
    updateSelection({ selected_color, selected_size, variant_id }) {
      const current = activeJob({ allowLatest: false });
      if (!current?.design_id) return;
      JOBS.update(current.job_id, {
        selected_color,
        selected_size,
        variant_id,
        selection: { selected_color, selected_size, variant_id }
      });
    },
    matches(productHandle, style) {
      const current = JOBS.getActive(jobContext(productHandle, style));
      return Boolean(
        current?.status === 'completed' &&
        current.design_id &&
        current.thumb_url &&
        JOBS.sameContext(current, jobContext(productHandle, style))
      );
    },
    clear() {
      JOBS.clearActive(jobContext(), { removeRecord: true });
    }
  };

  const PENDING = {
    get(productHandle = state.productHandle, style = state.selectedStyle) {
      return JOBS.getActive(jobContext(productHandle, style));
    },
    set(data, productHandle = state.productHandle, style = state.selectedStyle) {
      const context = jobContext(productHandle, style);
      const record = JOBS.create(context, {
        ...data,
        status: data.status || 'queued',
        selection: {
          selected_color: data.selected_color,
          selected_size: data.selected_size,
          variant_id: data.variant_id
        }
      });
      if (record) JOBS.setActive(context, record.job_id);
      return record;
    },
    update(data, productHandle = state.productHandle, style = state.selectedStyle) {
      const current = JOBS.getActive(jobContext(productHandle, style), { allowLatest: false });
      if (!current) return null;
      return JOBS.update(current.job_id, data);
    },
    clear(productHandle = state.productHandle, style = state.selectedStyle) {
      const context = jobContext(productHandle, style);
      const current = JOBS.getActive(context, { allowLatest: false });
      if (current?.status !== 'completed') {
        JOBS.clearActive(context, { removeRecord: true });
      }
    },
    matches(job, productHandle = state.productHandle, style = state.selectedStyle) {
      return Boolean(
        job?.job_id &&
        job?.status !== 'failed' &&
        JOBS.sameContext(job, jobContext(productHandle, style))
      );
    }
  };

  const STYLE_TO_API = {
    cartoon: 'cartoon',
    flat_vector: 'cartoon',
    lineart: 'lineart',
    line_art: 'lineart',
    retro: 'retro',
    retro_poster: 'retro',
    sketch: 'sketch'
  };

  const STYLE_LABELS = {
    cartoon: 'Cartoon',
    flat_vector: 'Cartoon',
    lineart: 'Line Art',
    line_art: 'Line Art',
    retro: 'Retro',
    retro_poster: 'Retro',
    sketch: 'Sketch'
  };

  const PF_MAP = (() => {
    try {
      const el = document.getElementById('vsp-printful-map');
      return el ? JSON.parse(el.textContent) : {};
    } catch {
      return {};
    }
  })();

  const state = {
    productHandle: root.dataset.productHandle || '',
    selectedStyle: root.dataset.style || '',
    product: null,
    variant: null,
    variantId: null,
    selectedColor: null,
    selectedSize: null,
    selectedQuantity: 1,
    previewRenderSeq: 0,
    generationSeq: 0
  };

  const MAX_IMAGE_PIXELS = 16777216;
  const MAX_IMAGE_BYTES = 20 * 1024 * 1024;
  const SUPPORTED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
  const MEN_SLIPPERS_EU_SIZE_MAP = Object.freeze({
    '6.5': '39',
    '7': '40',
    '8': '41',
    '8.5': '42',
    '9.5': '43',
    '10': '44',
    '11': '45',
    '11.5': '46',
    '12.5': '47'
  });
  const WOMEN_SLIPPERS_EU_SIZE_MAP = Object.freeze({
    '5.5': '36',
    '6.5': '37',
    '7': '38',
    '8': '39',
    '8.5': '40',
    '9.5': '41',
    '10': '42',
    '11': '43',
    '11.5': '44'
  });
  let statusTimer = null;
  const galleryImagePreloads = new Map();
  let gallerySwitchSeq = 0;

  function preloadGalleryImage(button, priority = 'low') {
    const src = button?.dataset?.full;
    if (!src) return Promise.resolve(null);

    const existing = galleryImagePreloads.get(src);
    if (existing) {
      if (priority === 'high') existing.image.fetchPriority = 'high';
      return existing.promise;
    }

    const image = new Image();
    image.decoding = 'async';
    image.fetchPriority = priority;

    const entry = { image, ready: false, promise: null };
    entry.promise = new Promise((resolve) => {
      let settled = false;
      const finish = async () => {
        if (settled) return;
        settled = true;
        try {
          await image.decode();
        } catch {
          // A successful load is still usable when decode() is unavailable or rejects.
        }
        entry.ready = true;
        resolve(image);
      };

      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', () => {
        if (settled) return;
        settled = true;
        galleryImagePreloads.delete(src);
        resolve(null);
      }, { once: true });
      image.src = src;

      if (image.complete && image.naturalWidth > 0) finish();
    });

    galleryImagePreloads.set(src, entry);
    return entry.promise;
  }

  function scheduleGalleryPreload() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const constrainedConnection = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    if (constrainedConnection) return;

    const start = () => {
      els.thumbs.slice(1).forEach((button, index) => {
        window.setTimeout(() => preloadGalleryImage(button), index * 120);
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      window.setTimeout(start, 600);
    }
  }

  function setStatus(message, visible = true, hideAfterMs = 7000) {
    if (!els.status) return;
    window.clearTimeout(statusTimer);
    els.status.textContent = String(message || '');
    els.status.classList.toggle('is-visible', Boolean(message && visible));
    if (message && visible && hideAfterMs > 0) {
      statusTimer = window.setTimeout(() => setStatus('', false, 0), hideAfterMs);
    }
  }

  function getCustomerErrorMessage(error, context = 'design') {
    const message = String(error?.message || error || '').toLowerCase();

    if (message.includes('16777216') || message.includes('resolution') || message.includes('pixel')) {
      return 'Das Bild hat eine zu hohe Aufloesung. Bitte waehle ein kleineres Bild und versuche es erneut.';
    }
    if (
      message.includes('413') ||
      message.includes('payload too large') ||
      message.includes('request entity too large') ||
      message.includes('file too large') ||
      message.includes('datei ist zu gross')
    ) {
      return 'Die Bilddatei ist zu gross. Bitte waehle ein kleineres Bild und versuche es erneut.';
    }
    if (
      message.includes('format') ||
      message.includes('mime') ||
      message.includes('decode') ||
      message.includes('unsupported') ||
      message.includes('heic') ||
      message.includes('heif')
    ) {
      return 'Dieses Bildformat wird nicht unterstuetzt. Bitte verwende ein JPG-, PNG- oder WebP-Bild.';
    }
    if (message.includes('timeout')) {
      return 'Die Erstellung dauert gerade zu lange. Bitte versuche es in einem Moment erneut.';
    }
    if (
      message.includes('failed to fetch') ||
      message.includes('network') ||
      message.includes('netzwerk') ||
      message.includes('job-status konnte nicht geladen')
    ) {
      return 'Die Verbindung wurde unterbrochen. Bitte pruefe deine Internetverbindung und versuche es erneut.';
    }
    if (
      message.includes('moderation') ||
      message.includes('safety') ||
      message.includes('content policy')
    ) {
      return 'Dieses Bild konnte leider nicht verarbeitet werden. Bitte waehle ein anderes Bild.';
    }
    if (context === 'cart') {
      return 'Der Artikel konnte gerade nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.';
    }
    if (context === 'product') {
      return 'Die Produktdaten konnten gerade nicht geladen werden. Bitte lade die Seite erneut.';
    }
    return 'Das Design konnte leider nicht erstellt werden. Bitte waehle ein anderes Bild oder versuche es erneut.';
  }

  function readImageDimensions(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      const cleanup = () => URL.revokeObjectURL(url);
      image.onload = () => {
        const dimensions = {
          width: image.naturalWidth,
          height: image.naturalHeight
        };
        cleanup();
        resolve(dimensions);
      };
      image.onerror = () => {
        cleanup();
        reject(new Error('unsupported image format'));
      };
      image.src = url;
    });
  }

  async function validateUploadFile(file) {
    if (!file) throw new Error('Kein Upload vorhanden.');
    if (!SUPPORTED_IMAGE_TYPES.has(String(file.type || '').toLowerCase())) {
      throw new Error('unsupported image format');
    }
    if (file.size > MAX_IMAGE_BYTES) {
      throw new Error('datei ist zu gross');
    }
    const { width, height } = await readImageDimensions(file);
    if (!width || !height) throw new Error('unsupported image format');
    if (width * height > MAX_IMAGE_PIXELS) {
      throw new Error('image resolution exceeds 16777216 pixels');
    }
  }

  function getStyleLabel(style) {
    return STYLE_LABELS[style] || STYLE_LABELS[STYLE_TO_API[style]] || String(style || '');
  }

  function renderProductTitle(productTitle) {
    if (!els.productTitle) return;
    els.productTitle.textContent = '';
    const span = document.createElement('span');
    span.textContent = productTitle || '';
    els.productTitle.appendChild(span);
  }

  function mapStyleToApi(style) {
    const key = String(style || '')
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, '_');
    return STYLE_TO_API[key] || '';
  }

  function getPrintfulVariantId(shopifyVariantId) {
    const value = PF_MAP[String(shopifyVariantId)];
    return value && String(value).trim() ? String(value).trim() : null;
  }

  function formatProductPrice(cents) {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount / 100);
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'short' }).format(date);
  }

  function renderDeliveryRange() {
    if (!els.delivery) return;
    const start = new Date();
    const end = new Date();
    start.setDate(start.getDate() + 6);
    end.setDate(end.getDate() + 12);
    els.delivery.textContent = `Lieferung ca. ${formatDate(start)} - ${formatDate(end)}`;
  }

  function guessColorHex(label) {
    const key = String(label || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00df/g, 'ss');
    const hexMatch = key.match(/#([0-9a-f]{6})/i);
    if (hexMatch) return `#${hexMatch[1]}`;

    const rules = [
      // Spezifische mehrteilige Farben zuerst
      [/navy blazer|navy-blazer/, '#171f2c'],
      [/charcoal heather|anthrazit meliert/, '#463e3d'],
      [/vintage black|vintage schwarz/, '#43413D'],
      [/team royal|team konigsblau|team koenigsblau/, '#1b43ae'],
      [/forest green|waldgrun|waldgruen/, '#1A3B23'],
      [/turf green|rasengrun|rasengruen/, '#187532'],
      [/military green|militargrun|militaergruen/, '#5c4f32'],
      [/carolina blue|carolina-blau/, '#98b7ee'],
      [/tropical blue|tropisches blau/, '#00A0B3'],
      [/carbon grey|carbon gray|carbongrau|karbongrau/, '#c7c3be'],
      [/graphite heather|graphit heather|graphit meliert/, '#858585'],
      [/light pink|hellrosa|hellpink/, '#ffd0cc'],
      [/sky blue|himmelblau/, '#d6edf7'],
      [/oatmeal heather|hafer meliert/, '#fbf2e1'],

      // Einzelfarben und direkte Übersetzungen
      [/maroon|kastanienbraun|weinrot|bordeaux/, '#47001b'],
      [/black|schwarz/, '#141313'],
      [/purple|lila|violett/, '#48197d'],
      [/cardinal|kardinal/, '#c21b3a'],
      [/royal|konigsblau|koenigsblau/, '#175ac7'],
      [/sapphire|saphir/, '#007AB3'],
      [/heliconia|helikonie/, '#E33F7A'],
      [/azalea|azalee/, '#ff98c6'],
      [/white|weiss/, '#ffffff'],
      [/anthracite|anthrazit/, '#3e383e'],
      [/khaki/, '#6E6B4D'],
      [/desert dust|wustenstaub|wuestenstaub/, '#dcccb4'],
      [/lavender|lavendel/, '#f7ecff'],
      [/navy|marineblau|dunkelblau/, '#16263f'],
      [/charcoal|holzkohle/, '#74716b'],
      [/gold/, '#ffad20'],
      [/sport grey|sport gray|sportgrau/, '#d1d1d1'],
      [/light blue|hellblau/, '#C1D5E6'],
      [/natural|naturlich/, '#f8eddc'],

      // Allgemeine Auffangregeln immer zuletzt
      [/heather|meliert/, '#babdc0'],
      [/pink|rosa/, '#ffb2da'],
      [/grey|gray|grau/, '#d1d1d1'],
      [/blue|blau/, '#3f7ec4'],
      [/green|grun|gruen/, '#1a5a32'],
      [/red|rot/, '#9f1d2f'],
      [/yellow|gelb/, '#ffad20'],

      //neue Farben nach Version 3.1
      [/sand/, '#d6c0ab'],
      [/himmel|sky/, '#8ee0ff'],
      [/asche|ash/, '#f3f3f3'],
      [/dunkles heather/, '#595959'],
      [/stargazer/, '#3d737d'],
      [/bone/, '#f5e8ce'],

    ];


    const match = rules.find(([test]) => test.test(key));
    return match ? match[1] : '#d1d5db';
  }

  function getContrastLineColor(hex) {
    const match = String(hex || '').match(/^#?([0-9a-f]{6})$/i);
    if (!match) return '#111111';
    const value = match[1];
    const red = parseInt(value.slice(0, 2), 16);
    const green = parseInt(value.slice(2, 4), 16);
    const blue = parseInt(value.slice(4, 6), 16);
    const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
    return luminance < 0.52 ? '#ffffff' : '#111111';
  }

  function normalizeOptionText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\u00df/g, 'ss');
  }

  function getOptionName(option) {
    return typeof option === 'string' ? option : option?.name;
  }

  function optionLooksLikeSize(option, index, product) {
    const values = option?.values || product?.variants?.map((variant) => variant.options?.[index]).filter(Boolean) || [];
    const sizePattern = /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl|6xl|nb|0-?3m|3-?6m|6-?12m|12-?18m|18-?24m)$/i;
    return values.some((value) => sizePattern.test(String(value || '').trim()));
  }

  function optionLooksLikeColor(option, index, product) {
    const values = option?.values || product?.variants?.map((variant) => variant.options?.[index]).filter(Boolean) || [];
    const colorPattern = /(black|white|maroon|purple|green|cardinal|royal|sapphire|heliconia|blue|heather|azalea|navy|charcoal|pink|lavender|grey|gray|khaki|gold|schwarz|weiss|blau|grun|gruen|grau|rot|rosa|gelb|naturlich|anthracite|holzkohle)/i;
    return values.some((value) => colorPattern.test(normalizeOptionText(value)));
  }

  function getOptionIndexes(product) {
    const options = product?.options || [];
    const names = options.map((option) => normalizeOptionText(getOptionName(option)));
    let colorIndex = names.findIndex((name) => ['color', 'farbe', 'fabe'].includes(name) || name.includes('color') || name.includes('farbe'));
    let sizeIndex = names.findIndex((name) => ['size', 'groesse', 'grosse', 'gr'].includes(name) || name.includes('size') || name.includes('gross'));

    if (sizeIndex === -1) {
      sizeIndex = options.findIndex((option, index) => index !== colorIndex && optionLooksLikeSize(option, index, product));
    }
    if (colorIndex === -1) {
      colorIndex = options.findIndex((option, index) => index !== sizeIndex && optionLooksLikeColor(option, index, product));
    }

    return { colorIndex, sizeIndex };
  }

  function getColorsWithAvailability(product) {
    const { colorIndex } = getOptionIndexes(product);
    if (colorIndex === -1) return [];
    const map = new Map();
    product.variants.forEach((variant) => {
      const color = variant.options[colorIndex];
      if (!color) return;
      const current = map.get(color) || { color, available: false };
      if (variant.available) current.available = true;
      map.set(color, current);
    });
    return Array.from(map.values());
  }

  function sizeSortKey(value) {
    const key = String(value || '').toUpperCase().trim();
    const map = { XS: 1, S: 2, M: 3, L: 4, XL: 5, '2XL': 6, XXL: 6, '3XL': 7, '4XL': 8, '5XL': 9 };
    return map[key] || 999;
  }

  function getSizesWithAvailability(product, onlyForColor = null) {
    const { colorIndex, sizeIndex } = getOptionIndexes(product);
    if (sizeIndex === -1) return [];
    const map = new Map();
    product.variants.forEach((variant) => {
      if (onlyForColor && colorIndex !== -1 && variant.options[colorIndex] !== onlyForColor) return;
      const size = variant.options[sizeIndex];
      if (!size) return;
      const current = map.get(size) || { size, available: false };
      if (variant.available) current.available = true;
      map.set(size, current);
    });
    return Array.from(map.values()).sort((a, b) => sizeSortKey(a.size) - sizeSortKey(b.size));
  }

  function isMenSlippersProduct() {
    const productIdentity = {
      handle: state.productHandle,
      title: state.product?.title || ''
    };
    const detector = window.VanscapeMockupGenerator?.isMenSlippersProduct;
    if (typeof detector === 'function' && detector(productIdentity)) return true;

    const haystack = normalizeOptionText(`${productIdentity.handle} ${productIdentity.title}`);
    const mentionsMen = /(^|[\s/_-])(herren|men|mens|male)(?=$|[\s/_-])/.test(haystack);
    const mentionsSlippers = /(schlappen|badeschlappen|slides|slippers)/.test(haystack);
    return mentionsMen && mentionsSlippers;
  }

  function isWomenSlippersProduct() {
    const productIdentity = {
      handle: state.productHandle,
      title: state.product?.title || ''
    };
    const detector = window.VanscapeMockupGenerator?.isWomenSlippersProduct;
    if (typeof detector === 'function' && detector(productIdentity)) return true;

    const haystack = normalizeOptionText(`${productIdentity.handle} ${productIdentity.title}`);
    const mentionsWomen = /(^|[\s/_-])(damen|women|womens|female)(?=$|[\s/_-])/.test(haystack);
    const mentionsSlippers = /(schlappen|badeschlappen|slides|slippers)/.test(haystack);
    return mentionsWomen && mentionsSlippers;
  }

  function getSlippersEuSizeMap() {
    if (isMenSlippersProduct()) return MEN_SLIPPERS_EU_SIZE_MAP;
    if (isWomenSlippersProduct()) return WOMEN_SLIPPERS_EU_SIZE_MAP;
    return null;
  }

  function getSizeDisplayValue(size, sizeMap = getSlippersEuSizeMap()) {
    if (!sizeMap) return String(size || '');
    const normalizedSize = String(size || '').trim().replace(',', '.');
    return sizeMap[normalizedSize] || String(size || '');
  }

  function pickVariant() {
    if (!state.product) return;
    const { colorIndex, sizeIndex } = getOptionIndexes(state.product);
    state.variant = state.product.variants.find((variant) => {
      if (!variant.available) return false;
      const okColor = colorIndex === -1 || !state.selectedColor || variant.options[colorIndex] === state.selectedColor;
      const okSize = sizeIndex === -1 || !state.selectedSize || variant.options[sizeIndex] === state.selectedSize;
      return okColor && okSize;
    }) || state.product.variants.find((variant) => variant.available) || null;
    state.variantId = state.variant?.id || null;
    if (els.price) els.price.textContent = formatProductPrice(state.variant?.price ?? state.product?.price);
  }

  function persistCurrentSelection() {
    const selection = {
      selected_color: state.selectedColor,
      selected_size: state.selectedSize,
      variant_id: state.variantId
    };
    if (SS.matches(state.productHandle, state.selectedStyle)) {
      SS.updateSelection(selection);
    }
    const pendingJob = PENDING.get();
    if (PENDING.matches(pendingJob)) {
      PENDING.update(selection);
    }
  }

  function updateOptionVisibility() {
    if (!els.options) return;
    const hasColors = Boolean(els.colorList?.children.length);
    const hasSizes = Boolean(els.sizeList?.children.length);
    if (els.colorOption) els.colorOption.hidden = !hasColors;
    if (els.sizeOption) els.sizeOption.hidden = !hasSizes;
    els.options.hidden = !hasColors && !hasSizes;
    els.options.classList.toggle('has-single-option', hasColors !== hasSizes);
  }

  function renderColors(colors, preferredColor = null) {
    if (!els.colorList) return;
    els.colorList.innerHTML = '';
    const firstAvailable = colors.find((item) => item.available) || colors[0];
    const preferred = colors.find((item) => item.available && item.color === preferredColor);
    state.selectedColor = preferred?.color || firstAvailable?.color || null;
    colors.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vsp-swatch';
      const colorHex = guessColorHex(item.color);
      button.style.backgroundColor = colorHex;
      button.style.setProperty('--vsp-disabled-line', getContrastLineColor(colorHex));
      button.dataset.value = item.color;
      button.setAttribute('aria-label', item.color);
      button.classList.toggle('is-active', item.color === state.selectedColor);
      if (!item.available) {
        button.disabled = true;
        button.classList.add('is-disabled');
      }
      button.addEventListener('click', () => {
        state.selectedColor = item.color;
        $$('.vsp-swatch').forEach((swatch) => swatch.classList.toggle('is-active', swatch === button));
        if (els.colorName) els.colorName.textContent = item.color;
        renderSizes(getSizesWithAvailability(state.product, state.selectedColor));
        pickVariant();
        renderCurrentPreview();
        persistCurrentSelection();
        updateButtons();
      });
      els.colorList.appendChild(button);
    });
    if (els.colorName) els.colorName.textContent = state.selectedColor || '';
    updateOptionVisibility();
  }

  function renderSizes(sizes, preferredSize = null) {
    if (!els.sizeList) return;
    els.sizeList.innerHTML = '';
    const slippersEuSizeMap = getSlippersEuSizeMap();
    const usesEuSlipperSizes = Boolean(slippersEuSizeMap);
    if (els.sizeLabel) els.sizeLabel.textContent = usesEuSlipperSizes ? 'EU-Größe' : 'Größe';
    const firstAvailable = sizes.find((item) => item.available) || sizes[0];
    const preferred = sizes.find((item) => item.available && item.size === preferredSize);
    state.selectedSize = preferred?.size || firstAvailable?.size || null;
    sizes.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vsp-size';
      const displaySize = getSizeDisplayValue(item.size, slippersEuSizeMap);
      button.textContent = displaySize;
      button.dataset.value = item.size;
      button.setAttribute('aria-label', usesEuSlipperSizes ? `EU-Größe ${displaySize}` : `Größe ${displaySize}`);
      button.classList.toggle('is-active', item.size === state.selectedSize);
      if (!item.available) {
        button.disabled = true;
        button.classList.add('is-disabled');
      }
      button.addEventListener('click', () => {
        state.selectedSize = item.size;
        $$('.vsp-size').forEach((size) => size.classList.toggle('is-active', size === button));
        pickVariant();
        renderCurrentPreview();
        persistCurrentSelection();
        updateButtons();
      });
      els.sizeList.appendChild(button);
    });
    updateOptionVisibility();
  }

  function clampQuantity(value) {
    return Math.max(1, Number.parseInt(value, 10) || 1);
  }

  function syncQuantity(value) {
    state.selectedQuantity = clampQuantity(value);
    if (els.quantity) els.quantity.value = String(state.selectedQuantity);
    if (els.modalQuantity) els.modalQuantity.value = String(state.selectedQuantity);
    syncBuyNowForm();
  }

  function hasCurrentDesign() {
    return SS.matches(state.productHandle, state.selectedStyle);
  }

  function updateButtons() {
    const hasStyle = Boolean(mapStyleToApi(state.selectedStyle));
    const hasPrintfulVariant = Boolean(getPrintfulVariantId(state.variantId));
    const canBuy = Boolean(state.product && state.variantId && hasStyle && hasPrintfulVariant && hasCurrentDesign());
    if (els.preview) els.preview.disabled = !canBuy;
    if (els.add) els.add.disabled = !canBuy;
    if (els.modalAdd) els.modalAdd.disabled = !canBuy;
    if (els.buyNowWrap) els.buyNowWrap.hidden = !canBuy;
    syncBuyNowForm();
  }

  function closePreviewModal() {
    els.modal?.classList.remove('is-open');
    els.modal?.setAttribute('aria-hidden', 'true');
  }

  function getRenderedMainPreviewSrc() {
    const canvas = els.mainImage?.parentElement?.querySelector('.vs-preview-composite-canvas');
    if (canvas && canvas.style.display !== 'none' && canvas.width && canvas.height) {
      try {
        return canvas.toDataURL('image/png');
      } catch {}
    }
    return els.mainImage?.src || (hasCurrentDesign() ? SS.thumbUrl : '') || '';
  }

  async function renderModalPreview() {
    if (!els.modalImg || !els.modalPlaceholder) return false;
    const designThumbUrl = hasCurrentDesign() ? SS.thumbUrl : null;
    const baseImageUrl = getBasePreviewImageUrl();
    const generator = window.VanscapeMockupGenerator;

    if (designThumbUrl && baseImageUrl && generator?.renderProductPreview) {
      try {
        const rendered = await generator.renderProductPreview({
          productHandle: state.productHandle,
          productTitle: state.product?.title || '',
          variantTitle: state.variant?.title || '',
          selectedSize: state.selectedSize || '',
          productImageUrl: baseImageUrl,
          designThumbUrl,
          selectedColorHex: guessColorHex(state.selectedColor),
          imgEl: els.modalImg,
          placeholderEl: els.modalPlaceholder
        });
        if (rendered) return true;
      } catch (err) {
        console.warn('Popup-Mockup konnte nicht erstellt werden', err);
      }
    }

    const fallbackSrc = getRenderedMainPreviewSrc();
    if (!fallbackSrc) return false;
    els.modalImg.src = fallbackSrc;
    els.modalImg.style.display = 'block';
    return true;
  }

  async function openPreviewModal() {
    if (!els.modal || !els.modalImg) return;
    syncQuantity(state.selectedQuantity);
    els.modal.classList.add('is-open');
    els.modal.setAttribute('aria-hidden', 'false');
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await renderModalPreview();
  }

  function resetPersonalizerAfterCart() {
    state.generationSeq += 1;
    if (els.upload) els.upload.value = '';
    SS.clear();
    syncQuantity(1);
    setUploadMode('idle');
    restoreFirstGalleryImage();
    updateButtons();
  }

  function syncBuyNowForm() {
    if (!els.buyNowForm || !state.variantId) return;
    const currentDesign = hasCurrentDesign();
    const set = (selector, value) => {
      const input = els.buyNowForm.querySelector(selector);
      if (input) input.value = String(value || '');
    };
    set('[name="id"]', state.variantId);
    set('[name="quantity"]', state.selectedQuantity);
    set('[name="properties[_job_id]"]', currentDesign ? SS.jobId : '');
    set('[name="properties[_design_id]"]', currentDesign ? SS.designId : '');
    set('[name="properties[Style]"]', getStyleLabel(state.selectedStyle));
    set('[name="properties[_product_title]"]', state.product?.title);
    set('[name="properties[_product_handle]"]', state.productHandle);
    set('[name="properties[_shopify_variant_id]"]', state.variantId);
    set('[name="properties[_variant]"]', state.variant?.title);
    set('[name="properties[_farbe]"]', state.selectedColor);
    set('[name="properties[_farbe_hex]"]', guessColorHex(state.selectedColor));
    set('[name="properties[_groesse]"]', state.selectedSize);
    set('[name="properties[_printful_variant_id]"]', getPrintfulVariantId(state.variantId));
    set('[name="properties[_design_thumb]"]', currentDesign ? SS.thumbUrl : '');
    set('[name="properties[_personalizer_url]"]', window.location.pathname);
  }

  function wireGifOrSpinner(gifEl, spinnerEl) {
    if (!gifEl) {
      spinnerEl?.classList.add('is-visible');
      return;
    }
    if (gifEl.complete && gifEl.naturalWidth > 0) {
      gifEl.style.display = 'block';
      spinnerEl?.classList.remove('is-visible');
      return;
    }
    gifEl.onerror = () => {
      gifEl.style.display = 'none';
      spinnerEl?.classList.add('is-visible');
    };
    gifEl.onload = () => {
      gifEl.style.display = 'block';
      spinnerEl?.classList.remove('is-visible');
    };
    spinnerEl?.classList.add('is-visible');
  }

  function setUploadMode(mode) {
    if (els.uploadIdle) els.uploadIdle.hidden = mode !== 'idle';
    if (els.uploadPreview) els.uploadPreview.hidden = mode !== 'preview';
    if (els.uploadLoading) els.uploadLoading.hidden = mode !== 'loading';
  }

  function updateLoadingProgress(completedSteps = 0, totalSteps = 0) {
    const completed = Math.max(0, Number(completedSteps) || 0);
    const total = Math.max(0, Number(totalSteps) || 0);
    const percent = total > 0 ? Math.max(0, Math.min(100, (completed / total) * 100)) : 0;
    if (els.loadingSteps) els.loadingSteps.textContent = total > 0 ? `Schritt ${completed}/${total}` : 'Schritt wird vorbereitet...';
    if (els.loadingProgress) els.loadingProgress.style.width = `${percent}%`;
  }

  function normalizeShopifyImageUrl(image, width = 1200) {
    const raw = String(image || '').trim();
    if (!raw) return null;
    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch {
      return raw;
    }
  }

  function getBasePreviewImageUrl() {
    const variantImg = state.variant?.featured_image?.src || state.variant?.featured_image || null;
    return (
      normalizeShopifyImageUrl(variantImg) ||
      normalizeShopifyImageUrl(state.product?.featured_image) ||
      normalizeShopifyImageUrl(state.product?.images?.[0]) ||
      normalizeShopifyImageUrl(els.mainImage?.src) ||
      null
    );
  }

  function setMainImage(src, alt = '') {
    if (!els.mainImage || !src) return;
    els.mainImage.src = src;
    els.mainImage.alt = alt;
  }

  function setGalleryMode(hasGeneratedMockup) {
    root.classList.toggle('has-generated-mockup', Boolean(hasGeneratedMockup));
  }

  function clearGeneratedPreview() {
    const previewEl = els.mainImage?.parentElement;
    const overlayEl = previewEl?.querySelector('.vs-design-overlay');
    const colorLayerEl = previewEl?.querySelector('.vs-preview-color-layer');
    const canvasEl = previewEl?.querySelector('.vs-preview-composite-canvas');

    if (overlayEl) {
      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
    }
    if (colorLayerEl) {
      colorLayerEl.style.display = 'none';
      colorLayerEl.style.backgroundColor = 'transparent';
      colorLayerEl.style.width = '0';
      colorLayerEl.style.height = '0';
    }
    if (canvasEl) {
      const context = canvasEl.getContext?.('2d');
      context?.clearRect(0, 0, canvasEl.width, canvasEl.height);
      canvasEl.style.display = 'none';
      canvasEl.width = 0;
      canvasEl.height = 0;
    }
    if (els.placeholder) {
      els.placeholder.hidden = true;
      els.placeholder.style.display = 'none';
    }
  }

  function restoreFirstGalleryImage() {
    clearGeneratedPreview();
    setGalleryMode(false);
    const firstThumb = els.thumbs[0];
    if (!firstThumb) return;
    els.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === firstThumb));
    setMainImage(firstThumb.dataset.full || firstThumb.querySelector('img')?.src, firstThumb.querySelector('img')?.alt || '');
    if (els.mainImage) {
      els.mainImage.style.display = 'block';
      els.mainImage.style.position = '';
      els.mainImage.style.zIndex = '';
    }
  }

  async function renderCurrentPreview() {
    const requestSeq = ++state.previewRenderSeq;
    const designThumbUrl = hasCurrentDesign() ? SS.thumbUrl : null;
    const baseImageUrl = getBasePreviewImageUrl();
    const generator = window.VanscapeMockupGenerator;

    if (!designThumbUrl || !baseImageUrl || !generator?.renderProductPreview) return false;

    let previewImg = els.mainImage;
    let placeholder = els.placeholder;
    if (!previewImg || !placeholder) return false;

    try {
      const rendered = await generator.renderProductPreview({
        productHandle: state.productHandle,
        productTitle: state.product?.title || '',
        variantTitle: state.variant?.title || '',
        selectedSize: state.selectedSize || '',
        productImageUrl: baseImageUrl,
        designThumbUrl,
        selectedColorHex: guessColorHex(state.selectedColor),
        imgEl: previewImg,
        placeholderEl: placeholder
      });
      if (requestSeq !== state.previewRenderSeq) return false;
      if (rendered) {
        setGalleryMode(true);
        return true;
      }
    } catch (err) {
      console.warn('Lokales Mockup konnte nicht erstellt werden', err);
    }

    if (requestSeq !== state.previewRenderSeq) return false;
    setMainImage(designThumbUrl, 'Design Vorschau');
    setGalleryMode(true);
    return true;
  }

  async function createRenderJob() {
    const file = els.upload?.files?.[0];
    if (!file) throw new Error('Kein Upload vorhanden.');
    const apiStyle = mapStyleToApi(state.selectedStyle);
    if (!apiStyle) throw new Error('Design Style fehlt oder ist ungueltig.');
    const fd = new FormData();
    fd.append('image', file);
    fd.append('style', apiStyle);
    const response = await fetch('/apps/vanscape/design/render', {
      method: 'POST',
      body: fd,
      credentials: 'include'
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.detail || 'Render-Request fehlgeschlagen.');
    if (!data?.job_id) throw new Error('job_id fehlt in der Render-Response.');
    return data;
  }

  async function pollRenderJob(jobId, { onProgress } = {}) {
    const started = Date.now();
    let retryDelay = 2500;

    const pollingError = (message, { recoverable = false, status = 0 } = {}) => {
      const error = new Error(message);
      error.recoverable = recoverable;
      error.httpStatus = status;
      return error;
    };

    while (Date.now() - started < 10 * 60 * 1000) {
      let response;
      try {
        response = await fetch(`/apps/vanscape/jobs/${encodeURIComponent(jobId)}`, {
          method: 'GET',
          credentials: 'include',
          headers: { Accept: 'application/json' }
        });
      } catch {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        retryDelay = Math.min(Math.round(retryDelay * 1.6), 15000);
        continue;
      }

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        if (response.status === 429 || response.status >= 500) {
          await new Promise((resolve) => setTimeout(resolve, retryDelay));
          retryDelay = Math.min(Math.round(retryDelay * 1.6), 15000);
          continue;
        }
        throw pollingError(
          data?.detail || 'Job-Status konnte nicht geladen werden.',
          { recoverable: false, status: response.status }
        );
      }

      retryDelay = 2500;
      onProgress?.(data);
      if (data?.status === 'failed') {
        throw pollingError(data?.error || 'Render-Job fehlgeschlagen.');
      }
      if (data?.status === 'completed' && data?.result) return data.result;
      await new Promise((resolve) => setTimeout(resolve, 2500));
    }
    throw pollingError(
      'Die Verbindung zum Render-Job wurde unterbrochen. Lade die Seite neu, um den Job weiterzuverfolgen.',
      { recoverable: true }
    );
  }

  async function finishRenderJob({ jobId, generationSeq, pendingJob = null }) {
    const result = await pollRenderJob(jobId, {
      onProgress: ({ status, completed_steps, total_steps }) => {
        if (generationSeq !== state.generationSeq) return;
        updateLoadingProgress(completed_steps, total_steps);
        PENDING.update({
          status: status || 'processing',
          completed_steps: completed_steps || 0,
          total_steps: total_steps || 0
        });
      }
    });

    if (generationSeq !== state.generationSeq) return null;

    SS.setDesign({
      job_id: jobId,
      design_id: result.design_id,
      thumb_url: result.thumb_url,
      style: state.selectedStyle,
      product_handle: state.productHandle,
      selected_color: pendingJob?.selected_color || state.selectedColor,
      selected_size: pendingJob?.selected_size || state.selectedSize,
      variant_id: pendingJob?.variant_id || state.variantId
    });
    PENDING.clear();

    await renderCurrentPreview();
    if (generationSeq !== state.generationSeq) return null;

    setUploadMode('preview');
    if (els.uploadThumb && result.thumb_url) els.uploadThumb.src = result.thumb_url;
    if (els.uploadName) els.uploadName.textContent = 'Dein Design ist fertig.';
    setStatus('', false);
    updateButtons();
    return result;
  }

  async function markJobAsCart(jobId) {
    if (!jobId) return;
    await fetch(`/apps/vanscape/jobs/${encodeURIComponent(jobId)}/purchase-state`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ purchase_state: 'cart' })
    });
  }

  async function addCurrentProductToCart() {
    if (!state.variantId || !hasCurrentDesign()) return false;
    const printfulVariantId = getPrintfulVariantId(state.variantId);
    if (!printfulVariantId) {
      throw new Error('Printful Variant-ID fehlt fuer die ausgewaehlte Variante.');
    }
    setStatus('Wird in den Warenkorb gelegt...');
    const payload = {
      items: [{
        id: state.variantId,
        quantity: clampQuantity(state.selectedQuantity),
        properties: {
          Style: getStyleLabel(state.selectedStyle),
          _job_id: SS.jobId || '',
          _design_id: SS.designId || '',
          _product_title: state.product?.title || '',
          _product_handle: state.productHandle || '',
          _shopify_variant_id: String(state.variantId || ''),
          _variant: state.variant?.title || '',
          _farbe: state.selectedColor || '',
          _farbe_hex: guessColorHex(state.selectedColor),
          _groesse: state.selectedSize || '',
          _printful_variant_id: printfulVariantId,
          _design_thumb: SS.thumbUrl || '',
          _personalizer_url: window.location.pathname
        }
      }]
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      setStatus(getCustomerErrorMessage(data?.description || data?.message, 'cart'));
      return false;
    }
    try { await markJobAsCart(SS.jobId); } catch {}
    setStatus('Im Warenkorb. Du kannst direkt weiter shoppen.');
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  async function runDesignGeneration(generationSeq = state.generationSeq) {
    try {
      await validateUploadFile(els.upload?.files?.[0]);
      if (generationSeq !== state.generationSeq) return;
      setUploadMode('loading');
      wireGifOrSpinner(els.loadingGif, els.loadingSpinner);
      updateLoadingProgress(0, 0);
      setStatus('Design wird erstellt...', false);
      const queued = await createRenderJob();
      if (generationSeq !== state.generationSeq) return;
      PENDING.set({
        job_id: queued.job_id,
        selected_color: state.selectedColor,
        selected_size: state.selectedSize,
        variant_id: state.variantId,
        total_steps: queued?.total_steps || 0,
        completed_steps: 0
      });
      updateLoadingProgress(0, queued?.total_steps || 0);
      const result = await finishRenderJob({ jobId: queued.job_id, generationSeq });
      if (result) openPreviewModal();
    } catch (err) {
      if (generationSeq !== state.generationSeq) return;
      if (els.upload) els.upload.value = '';
      if (err?.recoverable) {
        setUploadMode('loading');
      } else {
        SS.clear();
        setUploadMode('idle');
        restoreFirstGalleryImage();
      }
      setStatus(getCustomerErrorMessage(err, 'design'));
    } finally {
      updateButtons();
    }
  }

  async function resumePendingDesignJob(pendingJob) {
    if (!PENDING.matches(pendingJob)) return false;

    state.generationSeq += 1;
    const generationSeq = state.generationSeq;
    setUploadMode('loading');
    wireGifOrSpinner(els.loadingGif, els.loadingSpinner);
    updateLoadingProgress(pendingJob.completed_steps || 0, pendingJob.total_steps || 0);
    setStatus('Dein Design wird weiter erstellt...', false);

    try {
      const result = await finishRenderJob({
        jobId: pendingJob.job_id,
        generationSeq,
        pendingJob
      });
      if (result) openPreviewModal();
      return Boolean(result);
    } catch (err) {
      if (generationSeq !== state.generationSeq) return false;
      if (!err?.recoverable) PENDING.clear();
      if (!hasCurrentDesign() && !err?.recoverable) {
        setUploadMode('idle');
        restoreFirstGalleryImage();
      }
      setStatus(getCustomerErrorMessage(err, 'design'));
      updateButtons();
      return false;
    }
  }

  async function loadProduct(handle) {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error(`Produkt konnte nicht geladen werden: ${handle}`);
    return response.json();
  }

  function removeCartKeyFromUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('vsp_cart_key')) return;
    url.searchParams.delete('vsp_cart_key');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  async function restoreDesignFromCartLink() {
    const cartKey = new URLSearchParams(window.location.search).get('vsp_cart_key');
    if (!cartKey) return false;

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart could not be loaded');
      const cart = await response.json();
      const item = cart?.items?.find((candidate) => candidate.key === cartKey);
      const properties = item?.properties || {};
      if (!item || !properties._design_id || !properties._design_thumb) {
        throw new Error('personalized cart item not found');
      }

      const cartStyle = mapStyleToApi(properties.Style || state.selectedStyle);
      if (
        properties._product_handle !== state.productHandle ||
        cartStyle !== mapStyleToApi(state.selectedStyle)
      ) {
        throw new Error('personalized cart item does not match this page');
      }

      SS.setDesign({
        job_id: properties._job_id,
        design_id: properties._design_id,
        thumb_url: properties._design_thumb,
        style: cartStyle,
        product_handle: properties._product_handle,
        selected_color: properties._farbe,
        selected_size: properties._groesse,
        variant_id: properties._shopify_variant_id || item.variant_id
      });
      state.selectedQuantity = clampQuantity(item.quantity);
      return true;
    } catch (err) {
      console.warn('Personalisierte Warenkorbposition konnte nicht wiederhergestellt werden', err);
      setStatus('Das gespeicherte Design konnte nicht geoeffnet werden. Bitte versuche es erneut.');
      return false;
    } finally {
      removeCartKeyFromUrl();
    }
  }

  async function initProduct() {
    if (!state.productHandle) {
      setStatus('Produkt-Handle fehlt in der Section-Konfiguration.');
      return;
    }
    renderDeliveryRange();
    setStatus('Produkt wird geladen...', false);
    try {
      state.product = await loadProduct(state.productHandle);
      const restoreSavedDesign = SS.matches(state.productHandle, state.selectedStyle);
      const pendingJob = PENDING.get();
      const restorePendingJob = !restoreSavedDesign && PENDING.matches(pendingJob);
      const savedVariant = restoreSavedDesign
        ? state.product.variants.find((variant) => String(variant.id) === String(SS.variantId))
        : restorePendingJob
          ? state.product.variants.find((variant) => String(variant.id) === String(pendingJob.variant_id))
        : null;
      const { colorIndex, sizeIndex } = getOptionIndexes(state.product);
      const savedColor = restoreSavedDesign
        ? (SS.selectedColor || savedVariant?.options?.[colorIndex] || null)
        : restorePendingJob
          ? (pendingJob.selected_color || savedVariant?.options?.[colorIndex] || null)
        : null;
      const savedSize = restoreSavedDesign
        ? (SS.selectedSize || savedVariant?.options?.[sizeIndex] || null)
        : restorePendingJob
          ? (pendingJob.selected_size || savedVariant?.options?.[sizeIndex] || null)
        : null;
      renderProductTitle(state.product.title);
      renderColors(
        getColorsWithAvailability(state.product),
        savedColor
      );
      renderSizes(
        getSizesWithAvailability(state.product, state.selectedColor),
        savedSize
      );
      pickVariant();
      let pendingJobResumed = false;
      if (restoreSavedDesign) {
        persistCurrentSelection();
        setUploadMode('preview');
        if (els.uploadThumb) els.uploadThumb.src = SS.thumbUrl;
        if (els.uploadName) els.uploadName.textContent = 'Dein Design ist fertig.';
        await renderCurrentPreview();
      } else if (restorePendingJob) {
        pendingJobResumed = await resumePendingDesignJob(pendingJob);
      }
      updateButtons();
      if (!mapStyleToApi(state.selectedStyle)) {
        if (els.upload) els.upload.disabled = true;
        setStatus('Konfigurationsfehler: Das Produktmetafeld custom.design_style fehlt oder ist ungueltig.', true, 0);
      } else if (!getPrintfulVariantId(state.variantId)) {
        setStatus('Konfigurationsfehler: Fuer die ausgewaehlte Variante fehlt custom.printful_variant_id.', true, 0);
      } else if (!restorePendingJob || pendingJobResumed) {
        setStatus('', false);
      }
    } catch (err) {
      setStatus(getCustomerErrorMessage(err, 'product'));
    }
  }

  els.thumbs.forEach((button) => {
    const prioritizeImage = () => preloadGalleryImage(button, 'high');
    button.addEventListener('pointerenter', prioritizeImage, { passive: true });
    button.addEventListener('pointerdown', prioritizeImage, { passive: true });
    button.addEventListener('focus', prioritizeImage, { passive: true });

    button.addEventListener('click', async () => {
      const switchSeq = ++gallerySwitchSeq;
      const fullSrc = button.dataset.full || button.querySelector('img')?.src;
      const thumbnail = button.querySelector('img');
      const preloadEntry = galleryImagePreloads.get(fullSrc);

      setGalleryMode(false);
      els.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));

      if (preloadEntry?.ready) {
        setMainImage(fullSrc, thumbnail?.alt || '');
        return;
      }

      // React immediately with the cached thumbnail while the sharp image finishes loading.
      setMainImage(thumbnail?.currentSrc || thumbnail?.src || fullSrc, thumbnail?.alt || '');
      const loadedImage = await preloadGalleryImage(button, 'high');
      if (!loadedImage || switchSeq !== gallerySwitchSeq || !button.classList.contains('is-active')) return;
      setMainImage(fullSrc, thumbnail?.alt || '');
    });
  });

  // Register the eagerly loaded hero and warm the remaining gallery after critical page work.
  if (els.thumbs[0]) preloadGalleryImage(els.thumbs[0], 'high');
  if (document.readyState === 'complete') {
    scheduleGalleryPreload();
  } else {
    window.addEventListener('load', scheduleGalleryPreload, { once: true });
  }

  els.upload?.addEventListener('change', () => {
    const file = els.upload.files?.[0];
    state.generationSeq += 1;
    SS.clear();
    if (!file) {
      setUploadMode('idle');
      updateButtons();
      return;
    }
    const url = URL.createObjectURL(file);
    if (els.uploadThumb) els.uploadThumb.src = url;
    if (els.uploadName) els.uploadName.textContent = file.name;
    updateButtons();
    runDesignGeneration(state.generationSeq);
  });

  els.uploadRemove?.addEventListener('click', () => {
    state.generationSeq += 1;
    if (els.upload) els.upload.value = '';
    SS.clear();
    PENDING.clear();
    setUploadMode('idle');
    restoreFirstGalleryImage();
    updateButtons();
  });

  els.preview?.addEventListener('click', () => {
    openPreviewModal();
  });

  els.modal?.addEventListener('click', (event) => {
    if (event.target?.dataset?.vspClose != null || event.target === els.modal) {
      closePreviewModal();
    }
  });

  els.quantityDecrease?.addEventListener('click', () => syncQuantity(state.selectedQuantity - 1));
  els.quantityIncrease?.addEventListener('click', () => syncQuantity(state.selectedQuantity + 1));
  els.quantity?.addEventListener('input', () => syncQuantity(els.quantity.value));
  els.add?.addEventListener('click', () => {
    addCurrentProductToCart().catch((err) => {
      setStatus(getCustomerErrorMessage(err, 'cart'));
    });
  });
  els.modalQuantityDecrease?.addEventListener('click', () => syncQuantity(state.selectedQuantity - 1));
  els.modalQuantityIncrease?.addEventListener('click', () => syncQuantity(state.selectedQuantity + 1));
  els.modalQuantity?.addEventListener('input', () => syncQuantity(els.modalQuantity.value));
  els.modalAdd?.addEventListener('click', async () => {
    try {
      const added = await addCurrentProductToCart();
      if (!added) return;
      closePreviewModal();
      resetPersonalizerAfterCart();
    } catch (err) {
      setStatus(getCustomerErrorMessage(err, 'cart'));
    }
  });
  els.accordions.forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      if (panel) panel.hidden = isOpen;
    });
  });

  async function bootstrap() {
    setUploadMode('idle');
    await restoreDesignFromCartLink();
    syncQuantity(state.selectedQuantity);
    await initProduct();
  }

  bootstrap();
})();
